import { useCallback } from 'react';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { MoveableObject } from 'foundations-components/transitional/components/MoveableObject';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useRelationalReportInfrastructure, useRelationalReportProperties, useRelationalReportAdvancedProperties } from 'report-customization-components/contexts/RelationalReportContext';
import { getColumnValue } from 'report-customization-components/lib/relational-report-utils/column-utils';
import { getPropertyDisplayText, removalIsDisabled } from 'report-customization-components/lib/relational-report-utils/property-utils';
import { SnowflakeReportUpdateActions } from 'reporting-snowflake/relational/updaters/report/use-snowflake-updater';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const RelationalReportSelectedPropertiesPanel = ({
  report,
  onChange,
  localRelationalUpdater,
  localAllAvailableColumns,
  localCurrentAllColumns
}) => {
  const {
    allPropertiesOptions
  } = useRelationalReportProperties();
  const {
    fullTableAndPropertyMeta: {
      data: tableAndPropertyMeta,
      error
    }
  } = useRelationalReportInfrastructure();
  const {
    formulaFieldExpressions
  } = useRelationalReportAdvancedProperties();
  const onRemoveProperty = useCallback(column => () => {
    const updatedReportDefinition = localRelationalUpdater(SnowflakeReportUpdateActions.REMOVE_COLUMN_FROM_STAGED_COLUMNS, {
      column
    });
    if (!updatedReportDefinition.error) {
      const updatedReport = report.set('reportDefinition', updatedReportDefinition.report.toMap());
      onChange(updatedReport);
    }
  }, [onChange, report, localRelationalUpdater]);
  if (error) {
    return /*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "report-customization-components.customization-components.data-columns-modal.config.error"
      })
    });
  }
  if (!tableAndPropertyMeta) {
    return /*#__PURE__*/_jsx(LoadingSpinner, {
      "data-test-id": "properties-loading",
      layout: "centered"
    });
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: localAllAvailableColumns.map(column => {
      const isRemovalDisabled = removalIsDisabled(getColumnValue(column), localCurrentAllColumns, formulaFieldExpressions);
      return /*#__PURE__*/_jsx(Tooltip, {
        disabled: !isRemovalDisabled,
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "report-customization-components.customization-components.data-columns-modal.config.disabledProperty"
        }),
        placement: "top",
        children: /*#__PURE__*/_jsx(MoveableObject, {
          onClose: onRemoveProperty(column),
          isCloseDisabled: isRemovalDisabled,
          draggable: false,
          children: /*#__PURE__*/_jsx("p", {
            children: getPropertyDisplayText(column, allPropertiesOptions)
          })
        })
      }, column.alias);
    })
  });
};
export default RelationalReportSelectedPropertiesPanel;